import {Component, OnInit} from '@angular/core';
import { isNullOrUndefined } from 'util';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import {UpdateTcsRequest} from '../../api/models/update-tcs-request';
import {GapQuoteDetail} from '../../api/models/gap-quote-detail';
import {GapService} from '../../api/services/gap/gap.service';
import {GlobalService} from '../../api/services/global/global.service';
import {GapQuoteDetailsResponse} from '../../api/models/gap-quote-details-response';

declare let jQuery: any;
declare let jcf: any;

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {
  updateTcsRequest: UpdateTcsRequest;
  gapQuoteDetail: GapQuoteDetail;
  todaysDate: string;
  productAcceptedByAgent: boolean;
  productAcceptedByClient: boolean;
  quoteAcceptedByAgent: boolean;
  quoteAcceptedByClient: boolean;
  enableButton: boolean;
  loading: boolean;

  currentDate = new Date();

  constructor(private gapService: GapService, private globalService: GlobalService,
              private router: Router) {
    this.updateTcsRequest = {};
    this.gapQuoteDetail = {};
  }

  ngOnInit() {
    this.globalService.scrollToTop();
    this.loading = true;

    if (this.globalService.gapQuoteDetailsResponse && this.globalService.gapQuoteDetailsResponse.QuoteDetails && this.globalService.gapQuoteDetailsResponse.QuoteDetails.length > 0) {
      this.processQuoteDetails(this.globalService.gapQuoteDetailsResponse);
    }
    this.reloadJcf();
  }

  processQuoteDetails(response: GapQuoteDetailsResponse) {
    this.gapQuoteDetail = response.QuoteDetails[0];

    this.reloadJcf();

    if (this.gapQuoteDetail.productTCsAccepted && this.gapQuoteDetail.quoteTCsAccepted) {
      this.enableButton = true;
    }

    if (this.gapQuoteDetail.productTCsAccepted) {
      if (this.gapQuoteDetail.productTCsAcceptedBy === 'Agent') {
        this.productAcceptedByAgent = true;
      } else if (this.gapQuoteDetail.productTCsAcceptedBy === 'Client') {
        this.productAcceptedByClient = true;
      }
    }

    if (this.gapQuoteDetail.quoteTCsAccepted) {
      if (this.gapQuoteDetail.quoteTCsAcceptedBy === 'Agent') {
        this.quoteAcceptedByAgent = true;
      } else if (this.gapQuoteDetail.quoteTCsAcceptedBy === 'Client') {
        this.quoteAcceptedByClient = true;
      }
    }

    if (isNullOrUndefined(this.gapQuoteDetail.productTCsAcceptedDate) || isNullOrUndefined(this.gapQuoteDetail.quoteTCsAccepted)) {
      this.todaysDate = formatDate(this.currentDate, 'dd-MM-yyyy', 'en-ZA', '+02');
    }

    this.reloadJcf();
    this.loading = false;
  }

  updateTerms() {
    this.updateTcsRequest.quoteId = this.gapQuoteDetail.quoteID;
    this.updateTcsRequest.acceptedBy = 'Client';
    if (this.gapQuoteDetail.productTCsAccepted && this.gapQuoteDetail.quoteTCsAccepted) {
      this.gapService
        .updateTermsConditions(this.updateTcsRequest)
        .subscribe(
          response => {
            this.enableButton = response;
            this.reloadJcf();
          });
    }
    this.reloadJcf();
  }

  reloadJcf() {
    jQuery(function () {
      jcf.replaceAll();
    });
  }

  viewQuote() {
    this.router.navigateByUrl('/display-quote');
  }
}
